module.exports = __webpack_public_path__ + "img/ic_radio.939f2edc.svg";